/** 바로구매 — 상세에서 고른 상품만 결제 대상으로 넘긴다. */

const STORAGE_KEY = 'portal.mall.buyNowKeys'

function readKeys(): string[] {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : []
  } catch {
    return []
  }
}

export function setBuyNowKeys(keys: string[]) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(keys.filter(Boolean)))
  } catch {
    /* ignore */
  }
}

export function getBuyNowKeys(): string[] {
  return readKeys()
}

export function clearBuyNowKeys() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}

export function isBuyNowCheckoutQuery(query: Record<string, unknown> | { mode?: unknown }) {
  return String(query.mode || '') === 'buynow'
}
